<script setup>
import { useScroll } from '@vueuse/core'
import DetailHot from '@/views/Detail/components/DetailHot.vue'
import TitleComponent from '@/components/TitleComponent/index.vue'
import ImagePreview from "@/components/ImagePreview/index.vue"
import { ref, computed, onMounted, watch, nextTick } from 'vue';
import { exchangeRate } from '@/utils/index'
import { ElMessage } from 'element-plus'
import { getthirdDetail } from "@/apis/detail"
import { useRoute } from 'vue-router'
import routers from '@/router';
import { useHead } from '@vueuse/head';
import { useCartStore } from '@/stores/cartStore'
import { useUserStore } from '@/stores/userStore'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n();
const userStore = useUserStore()
const cartStore = useCartStore()
const mateTitle = ref();
const goods = reactive({
    data: {
        item: {
            price: null,
            title: '',
            pic_url: "",
            item_imgs: [],
            props_name: null,
            skus: {
                sku: []
            },
            desc_img: [],
            props: []
        },
        freightFee: null,
        salesCount: null,
        shopUserId: null,
        shop_user_name: null,
    },
    itemUrl: [],
    groupedProps: {},// 创建一个空对象来存储不同前缀的数组
    commodity: [],
    checkSku: "",
    skuData: {
        properties_name: null,
    },
    price: null,
    checkIMG: null,
    myObject: {}
})


const route = useRoute()
const getGoods = async () => {

    // let thirdData = localStorage.getItem('thirdData')
    // 将JSON字符串转换回对象
    let params = route.params
    // const myObject = JSON.parse(thirdData);
    console.log(params.product_id)
    goods.myObject = params
    const res = await getthirdDetail({ id: goods.myObject.product_id, from: goods.myObject.from })
    if (res.code == 0) {
        goods.data = res.data
        mateTitle.value = goods.data.item.title
        goods.price = goods.data.item.price
    }
    //图片
    goods.data.item.item_imgs.map(item => {
        goods.itemUrl.push(item.url)
    })
    if (goods.data.item.props_name != '') {


        console.log(goods.data.item.props_name)
        // 使用分号作为分隔符将字符串转换为数组
        const array = goods.data.item.props_name.split(';');
        console.log('array', array)
        let transformedData = {}
        // if(goods.myObject.from=='micro' || goods.myObject.from=='taoBao'||goods.myObject.from=='TMall'){
        transformedData = Object.keys(goods.data.item.props_list).reduce((acc, key) => {
            const groupKey = key.split(':')[0]; // 获取分组的键，即第一个冒号前的数字
            if (!acc[groupKey]) {
                acc[groupKey] = []; // 如果该分组不存在，则初始化为空数组
            }
            // 将键值对添加到对应的分组数组中
            acc[groupKey].push({ key: key, value: goods.data.item.props_list[key] });
            return acc;
        }, {});
        // }else{
        //     transformedData = array.reduce((acc, item) => {
        //         const [keyPart, valuePart] = item.split(/:(.*)/);
        //         const groupKey = keyPart.split(':')[0];
        //         const entry = { key: item.split(':').slice(0, 2).join(':'), value: item.split(':').slice(2).join(':') };

        //         if (!acc[groupKey]) acc[groupKey] = [];
        //         acc[groupKey].push(entry);

        //         return acc;
        //     }, {});
        // }


        let finalData = {}
        console.log('值', transformedData)
        if (goods.myObject.from == 'TMall' || goods.myObject.from == 'taoBao') {
            const reversedGroups = Object.values(transformedData).reverse();
            finalData = Object.keys(reversedGroups).reduce((acc, curr, index) => {
                acc[index] = reversedGroups[curr];
                return acc;
            }, {});

        } else {
            // Rearrange the keys to "0" and "1"
            finalData = Object.keys(transformedData).reduce((acc, curr, index) => {
                acc[index] = transformedData[curr];
                return acc;
            }, {});
        }
        const groupedProps = finalData;
        goods.groupedProps = Object.values(groupedProps);
        //如果只有一个规格的话要判断商品的库存
        let skus = goods.data.item.skus.sku
        if (Object.values(groupedProps).length == 1) {

            for (let i = 0; i < goods.groupedProps.length; i++) {
                for (let z = 0; z < goods.groupedProps[i].length; z++) {
                    const data = skus.find(obj => obj.properties === goods.groupedProps[i][z].key);
                    if (data.quantity > 0) {
                        goods.groupedProps[i][z].check = true
                    } else {
                        goods.groupedProps[i][z].check = false
                    }

                }
            }
        }

        goods.commodity = goods.groupedProps;


    }
    //价格
    goods.price = goods.data.item.price;
    count.value = goods.data.item.min_num || 1
}


const isMobile = ref(false);//false代表pc
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    console.log('Is mobile device:', isMobile.value);
    getGoods()
    console.log('route.path', window.location.href)
    // console.log('route.params',route.params)
    window.addEventListener('scroll', () => {
        scrollHeight.value = window.scrollY; // 或者使用 document.documentElement.scrollTop 或 document.body.scrollTop;
        windowHeight.value = window.innerHeight;
        getHeight()
    });
    setTimeout(() => {
        contentHeight.value = contentRef.value.scrollHeight;
    }, 1000)
})

onUpdated(() => {
    useHead({
        title: '商品详情 - ' + mateTitle.value,
        meta: [
            { name: 'description', content: mateTitle.value }
        ]
    });
})

// count
const count = ref(1)
const countChange = (count) => {
    console.log(count);
}

const checkitem = ref([])
const checkitemName = ref([])
const skucheck = ref([])
// 函数：将字符串转换为对象
const strToObj = (str) => {
    const obj = {};
    str.split(';').forEach(pair => {
        const [key, value] = pair.split(':');
        obj[key] = value;
    });
    return obj;
}
const checkItem = (i, groupIndex, url, bool) => {
    if (bool == false) {
        return;
    } else {

        console.log(i.key)
        console.log(goods.groupedProps)
        let skus = goods.data.item.skus.sku
        console.log(i, groupIndex, url)
        checkitem.value[groupIndex] = i.key;
        checkitemName.value[groupIndex] = i.value.split(':')[1];
        console.log('checkitem.value', checkitem.value)
        console.log(skus)
        let filteredSkus = skus.filter(sku => sku.properties.includes(i.key));
        filteredSkus.forEach(item => {
            // 分割properties字符串
            const propertiesArray = item.properties.split(';');

            // 过滤掉包含1627207:24739504267的项
            const filteredProperties = propertiesArray.filter(prop => prop !== i.key);

            // 将过滤后的数组重新连接成字符串
            item.check = filteredProperties.join(';');
        });
        skucheck.value = filteredSkus
        //判断选中的值在不在sku里面
        for (let i = 0; i < goods.groupedProps.length; i++) {

            if (i != groupIndex) {
                console.log('下标', goods.groupedProps[i])
                for (let z = 0; z < goods.groupedProps[i].length; z++) {

                    // 检查当前项的id是否在array2中存在
                    const existsInArray2 = filteredSkus.some(item =>
                        item.check.includes(goods.groupedProps[i][z].key));
                    // quantity
                    // const data= filteredSkus.find(obj => obj.check.includes(goods.groupedProps[i][z].key));
                    // console.log('zhi----',data)
                    // if(data.quantity>0){
                    //     goods.groupedProps[i][z].check = true
                    // }else{
                    //     goods.groupedProps[i][z].check = false
                    // }

                    if (existsInArray2) {
                        const data = filteredSkus.find(obj => obj.check.includes(goods.groupedProps[i][z].key));
                        // console.log('zhi----',data.quantity)
                        if (data.quantity > 0) {
                            goods.groupedProps[i][z].check = true
                        } else {
                            goods.groupedProps[i][z].check = false
                        }
                        // goods.groupedProps[i][z].check = true
                    } else {
                        goods.groupedProps[i][z].check = false
                    }
                }
            }
        }
        console.log(goods.groupedProps)
        // 检查数组长度并根据长度决定输出格式
        if (checkitem.value.length === 1) {
            console.log(1);
            // 如果数组只有一个元素，直接输出该元素
            goods.checkSku = checkitem.value[0];
        } else if (checkitem.value.length > 1) {

            // 如果数组有两个或更多元素，使用 join 方法将它们连接成一个字符串
            goods.checkSku = checkitem.value.join(';');
        }

        if (Object.keys(goods.commodity).length == Object.values(checkitem.value).length) {
            // 拿到对应选中的sku数据
            console.log(goods.checkSku)
            goods.skuData = goods.data.item.skus.sku.find(obj => JSON.stringify(strToObj(obj.properties)) === JSON.stringify(strToObj(goods.checkSku)));
            console.log('sku值', goods.skuData)
            let values = Object.values(checkitemName.value);
            goods.skuData.properties_name = values.join(';');
            goods.price = goods.skuData.price
        }
        console.log(url)
        if (url) {
            goods.checkIMG = url
        }
    }
}
const loginModel = ref(false);
const handleClose = () => {
    loginModel.value = false
    window.location.reload();
}
// 立即购买
const BuyitNowCart = () => {
    // localStorage.setItem('order', '')
    console.log('goods.skuData',goods.skuData)
    if (userStore.userInfo.token) {
        let data = []
        let listitem = {
            selected: true,
            id: goods.data.item.num_iid,
            name: goods.data.item.title,
            needIntlPostage:true,//需要国际邮费
            description: "",
            price: goods.price,
            quantity: count.value,
            belong_user_id: goods.data.item.num_iid,
            belong_user: goods.data.item.nick,
            cover_url: goods.data.item.pic_url,
            status: 1,
            total_price: null,
            source: goods.myObject.from,
            sku_id:goods.skuData.sku_id,
             sku_name:goods.skuData.properties_name,
            // sku_info: goods.skuData
            //+goods.data.freightFee
        }
        let item = {
            type: 1,
            avatar: 'https://shopfile.51siteboost.com/shap-head-test/20250304/1741069084714129479.png',
            shop_user: '51shopy',//商家信息
            shop_user_id: goods.data.shopUserId,//商家信息
            list: [listitem],
            // sku: goods.skuData,
            num_iid: goods.data.item.num_iid,
            freightFee: goods.data.freightFee * count.value
        }
        data.push(item)
        console.log(data)
        localStorage.setItem('order', JSON.stringify(data))
        routers.push('/checkout')
    } else {
        // 2. 跳转到登录页
        loginModel.value = true
    }
}
const ClearCheckIMG = () => {
    goods.checkIMG = undefined
}
const drawer = ref(false)
const drawerClose = () => {
    drawer.value = false
}
// 添加购物车
const addCart = () => {
    if (userStore.userInfo.token) {
        console.log(goods.skuData)
        // if (skuObj.skuId) {
        // 规则已经选择 触发action
        if(goods.skuData.sku_id){
        const sku = {
            sku_id: goods.skuData.sku_id,
            properties_name: goods.skuData.properties_name,

        }
       

       
        cartStore.addCart({
            inventory: goods.skuData.quantity || 999,
            shop_user_id: goods.data.shopUserId,//商家id
            id: goods.data.item.num_iid, // 商品id
            needIntlPostage:true,//需要国际邮费
            name: goods.data.item.title, // 商品名称
            picture: goods.data.item.pic_url, // 图片
            price: goods.price, // 最新价格
            description: "", // 商品规格文本
            selected: true, // 商品是否选中
            num: count.value,
            sku_info: sku,
            edit:false,
            from: 'product',
            sku: goods.skuData.sku_id,
            source: goods.myObject.from
        })
        ElMessage({ type: 'success', message: t('setup12') })
    }else{
        return;
    }
    } else {
        // 2. 跳转到登录页
        loginModel.value = true
    }
}
const showTooltips = ref({});

const toggleTooltip = (index, show) => {
    showTooltips.value[index] = show;
}
const copyText = async () => {
    try {
        await navigator.clipboard.writeText(window.location.href);

        ElMessage({ type: 'success', message: t('cart74') });
    } catch (err) {
        ElMessage({ type: 'error', message: t('cart75') });
    }
}
const commodityElement = ref(null);
const goodsElement = ref(null);
const goodsHeight = ref(0)
const scrollHeight = ref(0);
const windowHeight = ref(0);
const commodityHeight = ref(0)
const specElement = ref(null);
const specHeight = ref(0)
const specLeft = ref(0)
const getHeight = () => {
    // setTimeout(() => {
    if (commodityElement.value) {
        commodityHeight.value = commodityElement.value.offsetHeight;

    }
    if (goodsElement.value) {
        goodsHeight.value = goodsElement.value.offsetHeight;

    }
    if (specElement.value) {
        let child = document.querySelector('#specElement');
        console.log('child', child.getBoundingClientRect().left)
        specHeight.value = specElement.value.offsetHeight;
        specLeft.value = child.getBoundingClientRect().left;
    }
    // }, 500);
}
const contentRef = ref(null);
const isExpanded = ref(false);
const contentHeight = ref(0);

const contentStyle = computed(() => {
    if (contentHeight.value < 588) {
        return {
            overflow: 'hidden',
            height: isExpanded.value ? `${contentHeight.value}px` : 'auto',
            transition: 'height 0.3s ease',
        };
    } else {
        return {
            overflow: 'hidden',
            height: isExpanded.value ? `auto` : '588px',
            transition: 'height 0.3s ease',
        };
    }
});

const showMoreButton = computed(() => {
    return contentHeight.value > 588;
});

const toggleExpand = () => {
    console.log(111111)
    isExpanded.value = !isExpanded.value;
    getHeight()

};

// 监听 goods.description 的变化
// watch(
//     () => goods.data.item.desc_img,
//     () => {
//         nextTick(() => {
//             contentHeight.value = contentRef.value.scrollHeight;
//         });
//     },
//     { immediate: true }
// );
// 纵向滚动的距离
const { y } = useScroll(window)
const submitBUT = (type) => {
    console.log('zhi', goods.skuData)
    if (goods.skuData.properties_name) {
        if (type == 1) {
            addCart()//加入购物车
        } else {
            BuyitNowCart()//立即购买
        }
    } else {
        console.log(Object.keys(goods.commodity), Object.values(checkitem))
        drawer.value = true
        checkImg.value = goods.itemUrl[0]

    }
}
const checkImg = ref()
const goBack = () => {
    routers.go(-1);
}
</script>

<template>
    <div>
        <div class="xtx-goods-page" v-if="isMobile == false">
            <div class="container">
                <!-- <TitleComponent :title="''" v-if="isMobile == true"></TitleComponent> -->

                <!-- 商品信息 -->
                <div class="info-container" ref="commodityElement">
                    <div>
                        <div class="goods-info">
                            <div class="commodity" ref="goodsElement" id="goodsElement">
                                <div class="media">
                                    <!-- 图片预览区 -->
                                    <ImagePreview :imageList="goods.itemUrl" :checkIMG="goods.checkIMG"
                                        @ClearCheckIMG="ClearCheckIMG" />
                                    <!-- <ImagePreview v-else :imageList="goods.itemUrl" @ClearCheckIMG="ClearCheckIMG" /> -->
                                </div>
                                <div class="title">
                                    <div class="name">{{ $t("setup49") }}</div>
                                </div>
                                <div class="detail-container" v-if="goods.data.item.desc_img.length > 0"
                                    style="width: 100%;">
                                    <!-- <ProductDetails @getHeight="getHeight" :description="goods.description"
                                            v-if="goods.description != ''">
                                        </ProductDetails> -->
                                    <div class="productDetails">

                                        <div ref="contentRef" :style="contentStyle">
                                            <img :src="Pictures" style="width: 100%;" alt="Image 1"
                                                v-for="(Pictures, index) in goods.data.item.desc_img" :key="index">
                                        </div>
                                        <div v-if="showMoreButton" @click="toggleExpand"
                                            :class="[isExpanded ? 'noExpanded' : 'isExpanded', 'showMoreButton']">

                                            <div class="textbut"> {{ isExpanded ? $t('setup460') : $t('setup459') }}<img
                                                    v-if="isExpanded == false" src="../../assets/images/xia.png"
                                                    style="margin-left:6px;width: 10px;height: 7px;" /></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="spec" v-if="isMobile == false" ref="specElement" id="specElement"
                            :style="scrollHeight > 90&&(goodsHeight > specHeight) && (scrollHeight < (commodityHeight - specHeight + 90)) ? `position: fixed;left: ${specLeft}px;z-index: 10;top:70px` : scrollHeight >= (commodityHeight - specHeight + 90)&&(goodsHeight > specHeight) ? 'position: absolute;left: 580px;bottom:0px' : ''">
                                                       <!-- :style="scrollHeight > 90 && (scrollHeight < (commodityHeight - specHeight + 90)) ? `position: fixed;left: ${specLeft}px;z-index: 10;top:70px` : scrollHeight >= (commodityHeight - specHeight + 90) ? 'position: absolute;left: 580px;bottom:0px' : ''"> -->

                            <div class="specTop"></div>
                                <!-- 商品信息区 -->
                                <div class="specTitle" style="   ">
                                    <div class="spec-name">
                                        {{ goods.data.item.title }}</div>
                                    <div @click="copyText()">
                                        <svg-icon icon-class="shares" style="width: 20px;height: 20px;" />
                                    </div>
                                </div>
                                <!-- 商品信息区 -->
                                <!-- <p class="g-desc"> {{ goods.data.item.desc_short }} </p> -->
                                <div class="info-price">
                                    <div class="price">
                                        <span v-if="userStore.exchangeRate.symbol == '￥'"> ¥{{ goods.price }}</span>
                                        <span v-else>{{ exchangeRate(goods.price,
                                            userStore.exchangeRate.symbol, userStore.exchangeRate.rate) }}</span>
                                    </div>
                                    <div class="liang">
                                        {{ $t('setup439') }}&nbsp;{{ goods.data.salesCount }}
                                    </div>
                                    <!--  <div class="liang">
                                        {{ $t('setup31') }} &nbsp;{{ inventory }}
                                    </div> -->
                                </div>
                                <!-- <p class="g-price">
                                    <span> {{
                                        exchangeRate(goods.price, userStore.exchangeRate.symbol, userStore.exchangeRate.rate)
                                    }} </span>
                                
                                </p> -->
                                <div class="freightFee">
                                    {{ $t('setup51') }} <div class="fee">{{ exchangeRate(goods.data.freightFee,
                                        userStore.exchangeRate.symbol, userStore.exchangeRate.rate) }}</div>
                                    <div class="currency">{{ userStore.exchangeRate.currency }}</div>
                                </div>

                                <!-- 规格  sku组件 :class="checkitem[index] === i.key ? 'checkitem' : 'item'" isDisabled -->
                                <div class="Specification" v-for="(item, index) in goods.groupedProps" :key="index">
                                    <div class="title">{{ item[0].value.split(':')[0] }}:{{ checkitemName[index] }}
                                    </div>
                                    <div class="SpecificationIMG">
                                        <div v-for="(i, indexs) in item" :key="indexs" class="Specificationitem"
                                            @click="checkItem(i, index, goods.data.item.props_img[i.key], i?.check)">
                                            <div :class="[i?.check == false ? 'isDisabled' : '', checkitem[index] === i.key && i?.check != false ? 'checkitem' : 'item', 'flexcolumn']"
                                                v-if="goods.data.item.props_img[i.key]">
                                                <img :src="goods.data.item.props_img[i.key]" alt="" srcset="">
                                                <span class="imgname" style="    text-align: center;">{{ i.value.split(':')[1] }}</span>
                                            </div>
                                            <div class="skudata"
                                                :class="[i?.check == false ? 'isDisabled' : '', checkitem[index] === i.key && i?.check != false ? 'checkitemname' : 'itemname']"
                                                v-if="!goods.data.item.props_img[i.key]">
                                                {{ i.value.split(':')[1]
                                                }}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <!-- 数据组件 -->
                                <div class="number">
                                    {{ $t("cart3") }}：<el-input-number v-model="count" @change="countChange"
                                        :min="goods.data.item.min_num == 0 ? 1 : goods.data.item.min_num" />


                                </div>
                                <!-- 最低购买数量 -->
                                <div v-if="goods.myObject.from == '1688'" style="padding-top: 15px;">
                                    <div v-if="goods.data.item.min_num > 1">{{ $t("setup54")
                                        }}：{{ goods.data.item.min_num }}</div>
                                </div>
                                <!-- 按钮组件 -->
                                <!-- 按钮组件 -->
                                <div class="buts pc" v-if="userStore.userInfo.id != goods.userId">
                                    <!-- <div size="large"
                                            :class="[goods.variableAttr?.length != checkedCount?.length ? 'isDisabled' : '', 'addcart']"
                                            @click="addCart">
                                            {{ $t("home29") }}
                                        </div>
                                        <div size="large"
                                            :class="[goods.variableAttr?.length != checkedCount?.length ? 'isDisabled' : '', 'Buynow']"
                                            @click="BuyitNowCart();">
                                            {{ $t("home28") }}
                                        </div> -->
                                    <div size="large" @click="addCart"
                                        :class="[Object.keys(goods.commodity).length != Object.values(checkitem).length ? 'isDisabled' : '', 'addcart']">
                                        {{ $t("home29") }}
                                    </div>
                                    <div size="large" @click="BuyitNowCart"
                                        :class="[Object.keys(goods.commodity).length != Object.values(checkitem).length ? 'isDisabled' : '', 'Buynow']">
                                        {{ $t("home28") }}
                                    </div>
                                </div>
                                <!-- <div class="pc">
                                
                                </div> -->
                            </div>
                            <div v-else class="spec">
                                <!-- 商品信息区 -->
                                <p class="g-name"> {{ goods.data.item.title }} </p>
                                <p class="g-desc"> {{ goods.data.item.desc_short }} </p>
                                <p class="g-price">
                                    <span> {{
                                        exchangeRate(goods.price, userStore.exchangeRate.symbol,
                                            userStore.exchangeRate.rate)
                                    }} </span>
                                    <!-- <span> {{ goods.data.item.orginal_price }} </span> -->
                                </p>
                                <div class="freightFee">
                                    {{ $t('setup51') }} <div class="fee">{{ exchangeRate(goods.data.freightFee,
                                        userStore.exchangeRate.symbol, userStore.exchangeRate.rate) }}</div>
                                    <div class="currency">{{ userStore.exchangeRate.currency }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="leaveComments">
                        <div class="title">
                            {{ $t('setup49') }}
                        </div> 
                        <div class="content" v-if="isMobile==false && goods.data.item.props?.length>0">
                            <div class="item" v-for="(item,index) in goods.data.item.props" :key="index">
                                <div class="lable">{{ item.name }}:</div>
                                <div  class="value" @mouseover="toggleTooltip(index, true)" @mouseleave="toggleTooltip(index, false)">
                                
                                    <el-tooltip
                                        class="box-item"
                                        effect="dark"
                                        :content="item.value"
                                        placement="top"
                                    >
                                    <span>{{ item.value }}</span>
                                    </el-tooltip>
                                
                                
                                </div>
                            

                            </div>
                        </div>

                    </div>
                        <div class="goods-footer">
                            <img :src="Pictures" alt="Image 1" v-for="(Pictures, index) in goods.data.item.desc_img"
                                :key="index">
                        </div>
                    <div class="phone">
                        <div class="goodsfixed">
                            <el-button type="warning" class="btn" @click="drawer = true">
                                {{ $t("home28") }}
                            </el-button>
                            <el-button type="warning" class="btn" @click="drawer = true">
                                {{ $t("home29") }}
                            </el-button>
                        </div>
                    </div> -->
                </div>
                <div class="goods-footer">
                    <!-- 24热榜+专题推荐 -->
                    <div class="goods-aside" v-if="userStore.userInfo.token">
                        <!-- 24小时 -->
                        <DetailHot :hot-type="1" />

                    </div>
                </div>
            </div>

        </div>
        <div v-else class="phoneDIV">
            <div class="notopdiv" :class="{ show: y > 30 }" style="background: #fff;" v-if="y > 40">

                <div @click="goBack">
                    <img src="../../assets/images/return1.png"
                        style="width: 22px;height: 18px; background-color: #f4f5f700;" alt="" srcset="">
                </div>
                <div>
                    <img src="../../assets/images/collect1.png"
                        style="width: 26px;height: 26px; background-color: #f4f5f700;"
                        v-if="goods.isCollection == 1 || goods.isCollection == 0" alt="" srcset=""
                        @click="setCollect(goods.id)">
                    <img src="../../assets/images/collects1.png"
                        style="width: 26px;height: 26px; background-color: #f4f5f700;" alt="" srcset=""
                        @click="setDelCollect(goods.id)" v-if="goods.isCollection == 2">
                    <img src="../../assets/images/share1.png" alt="" style="margin-left: 8px;" class="img"
                        @click="copyText()">
                </div>
            </div>
            <div class="topdiv" :class="{ show: y < 40 }" v-else>

                <div @click="goBack">
                    <img src="../../assets/images/return.png" alt="" srcset="" class="img">
                </div>
                <div>
                    <img src="../../assets/images/collect.png" v-if="goods.isCollection == 1 || goods.isCollection == 0"
                        alt="" srcset="" class="img" @click="setCollect(goods.id)">
                    <img src="../../assets/images/collects.png" alt="" srcset="" class="img"
                        @click="setDelCollect(goods.id)" v-if="goods.isCollection == 2">
                    <img src="../../assets/images/share.png" alt="" style="margin-left: 8px;" class="img"
                        @click="copyText()">
                </div>
            </div>
            <div class="carousel">
                <el-carousel height="250px" pause-on-hover="true" interval="10000">

                    <el-carousel-item v-for="item in goods.itemUrl" :key="item">
                        <img :src="item" alt="" srcset="" style="object-fit: cover;">
                        <!-- <h3 class="small justify-center" text="2xl">{{ item }}</h3> -->
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="ProductInfo">
                <div class="ProductInfo-title">{{ goods.data.item.title }}</div>

                <div class="info-price">
                    <div class="price">
                        <span v-if="userStore.exchangeRate.symbol == '￥'"> ¥{{ goods.price }}</span>
                        <span v-else>{{ exchangeRate(goods.price,
                            userStore.exchangeRate.symbol, userStore.exchangeRate.rate) }}</span>
                    </div>
                    <div class="liang">
                        {{ $t('setup439') }}&nbsp;{{ goods.data.salesCount }}
                    </div>
                </div>
                <div class="hrdiv"></div>
                <div class="Specification" v-for="(item, index) in goods.groupedProps" :key="index">
                    <div class="title">{{ item[0].value.split(':')[0] }}:{{ checkitemName[index] }}</div>
                    <div class="SpecificationIMG">
                        <div v-for="(i, indexs) in item" :key="indexs" class="Specificationitem"
                            @click="checkItem(i, index, goods.data.item.props_img[i.key], i?.check)">
                            <div :class="[i?.check == false ? 'isDisabled' : '', checkitem[index] === i.key && i?.check != false ? 'checkitem' : 'item', 'flexcolumn']"
                                v-if="goods.data.item.props_img[i.key]">
                                <img :src="goods.data.item.props_img[i.key]" alt="" srcset="">
                                <!-- <span class="imgname">{{ i.value.split(':')[1]}}</span> -->
                            </div>
                            <div class="skudata"
                                :class="[i?.check == false ? 'isDisabled' : '', checkitem[index] === i.key && i?.check != false ? 'checkitemname' : 'itemname']"
                                v-if="!goods.data.item.props_img[i.key]">
                                {{
                                    i.value.split(':')[1]
                                }}
                            </div>

                        </div>
                    </div>
                </div>
                <!-- 数据组件 -->
                <div class="number">
                    {{ $t("cart3") }}：<el-input-number v-model="count" @change="countChange"
                        :min="goods.data.item.min_num == 0 ? 1 : goods.data.item.min_num" />
                </div>
                <!-- 最低购买数量 -->
                <div v-if="goods.myObject.from == '1688'" style="padding-top: 15px;">
                    <div v-if="goods.data.item.min_num > 1">{{ $t("setup54") }}：{{ goods.data.item.min_num }}</div>
                </div>
            </div>
            <div class="ProductDetails">
                <div class="DetailsTitle">{{ $t("setup49") }}</div>
                <div class="Detailscontainer" style="width: 100%;">
                    <div class="productDetails">

                        <div ref="contentRef" :style="contentStyle">
                            <img :src="Pictures" style="width: 100%;" alt="Image 1"
                                v-for="(Pictures, index) in goods.data.item.desc_img" :key="index">
                        </div>
                        <div v-if="showMoreButton" @click="toggleExpand"
                            :class="[isExpanded ? 'noExpanded' : 'isExpanded', 'showMoreButton']">

                            <div class="textbut"> {{ isExpanded ? $t('setup460') : $t('setup459') }}<img
                                    v-if="isExpanded == false" src="../../assets/images/xia.png"
                                    style="margin-left:6px;width: 10px;height: 7px;" /></div>
                        </div>
                    </div>
                    <!-- <ProductDetails :description="goods.description" v-if="goods.description != ''"></ProductDetails> -->
                </div>
            </div>
            <div class="Product-footer">
                <div class="goods-aside" v-if="userStore.userInfo.token">

                    <DetailHot :hot-type="1" />

                </div>
            </div>
            <div class="goodsfixed">
                <div class="butdiv">
                    <div style="width: 70px;display: flex;align-items: center;justify-content: space-between;">
                        <!-- <div v-if="goods.watchApp">
                            <img @click="drawer = true" src="../../assets/images/watch.png"
                                style="width: 30px;height: 30px;border-radius: 50%;" alt="" srcset="">

                        </div>
                        <div v-if="goods.telegram">
                            <img @click="drawer = true" src="../../assets/images/telegram.png"
                                style="width: 30px;height: 30px;" alt="" srcset="">

                        </div> -->
                    </div>
                    <div class="but">
                        <div size="large" :class="['addcart']" @click="submitBUT(1)">
                            {{ $t("home29") }}
                        </div>
                        <div size="large" :class="['Buynow']" @click="submitBUT(2)">
                            {{ $t("home28") }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog v-model="loginModel" width="350" :before-close="handleClose">
            <loginView :loginType="1" @close="handleClose" :type="1"></loginView>
        </el-dialog>
        <el-drawer v-model="drawer" show-close :with-header="false" direction="btt" :before-close="drawerClose"
            size="80%">
            <div class="closure" @click="drawer = false">
                <img src="../../assets/images/closure.png" alt="" srcset="">
            </div>
            <div class="imgPrice">
                <img :src="checkImg" alt="" srcset="" style="width: 82px;height: 82px;">
                <div class="numprice">
                    <div class="name">
                        {{ goods.data.item.title }}
                    </div>
                    <div class="price">
                        <span v-if="userStore.exchangeRate.symbol == '￥'"> ¥{{ goods.price }}</span>
                        <span v-else>{{ exchangeRate(goods.price,
                            userStore.exchangeRate.symbol, userStore.exchangeRate.rate) }}</span>
                    </div>
                </div>
            </div>
            <div class="Specification" v-for="(item, index) in goods.groupedProps" :key="index">
                <div class="title">{{ item[0].value.split(':')[0] }}:{{ checkitemName[index] }}</div>
                <div class="SpecificationIMG">
                    <div v-for="(i, indexs) in item" :key="indexs" class="Specificationitem"
                        @click="checkItem(i, index, goods.data.item.props_img[i.key], i?.check)">
                        <div :class="[i?.check == false ? 'isDisabled' : '', checkitem[index] === i.key && i?.check != false ? 'checkitem' : 'item', 'flexcolumn']"
                            v-if="goods.data.item.props_img[i.key]">
                            <img :src="goods.data.item.props_img[i.key]" alt="" srcset=""
                                @click="checkImg = goods.data.item.props_img[i.key];">
                            <!-- <span class="imgname">{{ i.value.split(':')[1]}}</span> -->
                        </div>
                        <div class="skudata"
                            :class="[i?.check == false ? 'isDisabled' : '', checkitem[index] === i.key && i?.check != false ? 'checkitemname' : 'itemname']"
                            v-if="!goods.data.item.props_img[i.key]">
                            {{
                                i.value.split(':')[1]
                            }}
                        </div>

                    </div>
                </div>
            </div>
            <!-- <div class="Specification" v-for="(item, index) in goods.groupedProps" :key="index">
                <div class="title">{{ item[0].value.split(':')[0] }}:{{ checkitemName[index] }}</div>
                <div class="SpecificationIMG">
                    <div v-for="(i, indexs) in item" :key="indexs"
                        :class="[checkitem[index] === i.key ? 'checkitem' : 'item', i?.check == false ? 'isDisabled' : '']"
                        @click="checkItem(i, index, goods.data.item.props_img[i.key], i?.check); ">

                        <img v-if="goods.data.item.props_img[i.key]" :src="goods.data.item.props_img[i.key]" alt="" @click="checkImg = goods.data.item.props_img[i.key];"
                            srcset="">

                        <span v-if="!goods.data.item.props_img[i.key]" style="padding:5px 10px;">{{ i.value.split(':')[1] }}</span>
                    </div>
                </div>
            </div> -->
            <div class="number">
                <span>{{ $t('cart29') }}：</span>
                <el-input-number style="margin-top: 10px;margin-bottom: 15px;" v-model="count" @change="countChange"
                    :min="goods.data.item.min_num == 0 ? 1 : goods.data.item.min_num" />

            </div>
            <div v-if="goods.myObject.from == '1688'">
                <div v-if="goods.data.item.min_num > 1"> {{ $t("setup54") }}：{{ goods.data.item.min_num }}</div>

            </div>
            <template #footer>
                <div class="dialog-footer">
                    <div class="butdiv">
                        <div style="width: 70px;display: flex;align-items: center;justify-content: space-between;">
                            <!-- <div v-if="goods.watchApp">
                                <img @click="drawer = true" src="../../assets/images/watch.png"
                                    style="width: 30px;height: 30px;border-radius: 50%;" alt="" srcset="">
                            </div>
                            <div v-if="goods.telegram">
                                <img @click="drawer = true" src="../../assets/images/telegram.png"
                                    style="width: 30px;height: 30px;" alt="" srcset="">

                            </div> -->
                        </div>
                        <div v-if="userStore.userInfo.id != goods.userId" class="but">
                            <div size="large"
                                :class="[Object.keys(goods.commodity).length != Object.values(checkitem).length ? 'isDisabled' : '', 'addcart']"
                                @click="addCart">
                                {{ $t("home29") }}
                            </div>
                            <div size="large"
                                :class="[Object.keys(goods.commodity).length != Object.values(checkitem).length ? 'isDisabled' : '', 'Buynow']"
                                @click="BuyitNowCart();">
                                {{ $t("home28") }}
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <!-- <div class="drawerSpec">
                <div class="titlediv">
                    <div class="titleimg">
                        <img v-if="goods.checkIMG" :src="goods.checkIMG" alt="" srcset="">
                        <img v-else :src="goods.data.item.pic_url" alt="" srcset="">
                    </div>
                    <div class="info">
                        <p class="g-name"> {{ goods.data.item.title }} </p>
                        <p class="g-desc"> {{ goods.data.item.desc_short }} </p>
                        <p class="g-price">
                            <span> {{ exchangeRate(goods.price, userStore.exchangeRate.symbol,
                                userStore.exchangeRate.rate) }}
                            </span>
                            
                        </p>
                    </div>
                </div>
                <div class="freightFee">
                    {{ $t('setup51') }} <div class="fee">{{ exchangeRate(goods.data.freightFee,
                        userStore.exchangeRate.symbol, userStore.exchangeRate.rate) }}</div>
                    <div class="currency">{{ userStore.exchangeRate.currency }}</div>
                </div>
              
                <div class="Specification" v-for="(item, index) in goods.groupedProps" :key="index">
                    <div class="title">{{ item[0].value.split(':')[0] }}:{{ checkitemName[index] }}</div>
                    <div class="SpecificationIMG">
                        <div v-for="(i, indexs) in item" :key="indexs"
                            :class="[checkitem[index] === i.key ? 'checkitem' : 'item', i?.check == false ? 'isDisabled' : '']"
                            @click="checkItem(i, index, goods.data.item.props_img[i.key], i?.check)">

                            <img v-if="goods.data.item.props_img[i.key]" :src="goods.data.item.props_img[i.key]" alt=""
                                srcset="">

                            <span v-if="!goods.data.item.props_img[i.key]" style="padding:5px 10px;">{{ i.value.split(':')[1] }}</span>
                        </div>
                    </div>
                </div>
                {{ $t("cart3") }}：<el-input-number style="margin-top: 10px;margin-bottom: 15px;" v-model="count"
                    @change="countChange" :min="goods.data.item.min_num == 0 ? 1 : goods.data.item.min_num" />
              
                <div v-if="goods.myObject.from=='1688'">
                    <div v-if="goods.data.item.min_num>1"> {{ $t("setup54") }}：{{goods.data.item.min_num}}</div>
                
                </div>
                <div class="drawerbut">

                    <el-button type="warning" class="btn" @click="BuyitNowCart"
                        :disabled="Object.keys(goods.commodity).length != Object.values(checkitem).length">
                        {{ $t("home28") }}
                    </el-button>
                    <el-button type="warning" class="btn" @click="addCart"  :disabled="Object.keys(goods.commodity).length != Object.values(checkitem).length">
                                    {{ $t("home29") }}
                                </el-button>
                </div>
            </div> -->
        </el-drawer>
    </div>
</template>

<style scoped lang='scss'>
.el-drawer {
    height: 70% !important;
    overflow-y: auto;
    /* 如果内容超出高度，可以添加滚动条 */
}

.full-text {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    /* 限制为两行 */
    overflow: hidden;
    text-overflow: ellipsis;
}

:deep(.el-drawer__body) {
    padding: 15px;
}

.productDetails {
    position: relative;

    .showMoreButton {
        position: absolute;
        width: 100%;
        background-image: url('@/assets/images/OcclusionBar.png');
        height: 68px;
        display: flex;
        justify-content: center;
        align-items: flex-end;

        .textbut {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #888888;
            line-height: 12px;
            text-align: left;
            font-style: normal;
            padding-bottom: 7px;
        }
    }

    .isExpanded {
        // top: 89%;
        bottom: 0;
    }

    .noExpanded {
        // top: 99%;
        bottom: 0;
    }
}

.xtx-goods-page {
    padding-top: 21px;
    padding-bottom: 90px;

    .leaveComments {
        .title {
            padding: 14px 10px;
            margin-top: 25px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            // border: 1px solid rgb(238, 238, 238);
            background: rgb(226, 98, 55);
            font-size: 14px;
            color: rgb(255, 255, 255);
        }

    }

    .goods-info {
        min-height: 600px;
        background: #fff;
        display: flex;

        align-items: flex-start;
        position: relative;

        .commodity {
            width: 580px;

            button {
                margin-top: 10px;
                padding: 5px 10px;
                cursor: pointer;
            }

            .productDetails {
                position: relative;

                .showMoreButton {
                    position: absolute;
                    width: 100%;
                    background-image: url('@/assets/images/OcclusionBar.png');
                    height: 68px;
                    display: flex;
                    justify-content: center;
                    align-items: flex-end;

                    .textbut {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 12px;
                        color: #888888;
                        line-height: 12px;
                        text-align: left;
                        font-style: normal;
                        padding-bottom: 7px;
                    }
                }

                .isExpanded {
                    // top: 89%;
                    bottom: 0;
                }

                .noExpanded {
                    // top: 99%;
                    bottom: 0;
                }
            }

            .title {
                margin-top: 50px;
                width: 580px;
                height: 68px;
                background: #F5F6F8;
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 24px;
                color: #11192D;
                line-height: 31px;
                text-align: left;
                font-style: normal;
                // padding: 25px 10px;margin-top: 25px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-left: 20px;
                // border: 1px solid #eeeeee;
                // background: #e26237;
                // font-size: 16px;
                // color: #fff;
            }

            .media {
                width: 580px;
                height: 480px;

                // padding: 30px 50px;
                .share {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    cursor: pointer;
                    //   padding: 10px;
                    //   background-color: #f0f0f0;
                    //   text-align: center;
                    //   border: 1px solid #ccc;
                }
            }

        }

        .spec {
            flex: 1;
            padding: 0 0 0 40px;
            // position: fixed;
            // top: 171px;
            /* 固定在顶部 */
            overflow-y: auto;
            height: auto;
            width: 620px;
            box-sizing: border-box;

            .specTop {
                width: 580px;
                height: 28px;
                background: #FC3938;
                border-radius: 4px;
            }

            .specTitle {
                display: flex;
                justify-content: space-between;
                margin-top: 20px;
                margin-bottom: 16px;

                .spec-name {
                    width: 550px;
                    font-family: MicrosoftYaHei;
                    font-size: 20px;
                    color: #11192D;
                    line-height: 26px;
                    text-align: left;
                    font-style: normal;
                }
            }

            .info-price {
                display: flex;
                padding-top: 6px;
                align-items: center;
                margin-bottom: 25px;

                .price {
                    font-family: MicrosoftYaHei, MicrosoftYaHei;
                    font-weight: bold;
                    // font-size: 15px;
                    font-size: 24px;
                    color: #FC3938;
                    line-height: 19px;
                    text-align: left;
                    font-style: normal;
                }

                .liang {
                    margin: 0 8px;
                    padding: 5px 8px;
                    background: #FEF1EA;
                    border-radius: 4px;
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #FC3938;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                }
            }

            .freightFee {
                margin: 5px 0;
                font-size: 14px;
                padding: 15px;
                border-radius: 6px;
                background-color: #f7f8f9;
                color: #212529;
                display: flex;
                align-items: center;

                .fee {
                    background: #e6e9ec;
                    padding: 6px 10px;
                    border: 1px solid #eef0f2;
                    margin-left: 5px;
                    border-top-left-radius: 10px;
                    border-bottom-left-radius: 10px;
                }

                .currency {
                    padding: 6px 10px;
                    border-top-right-radius: 10px;
                    border-bottom-right-radius: 10px;
                    background-color: #f7f8f9;
                    border: 1px solid #eef0f2;
                }
            }

            .Specification {
                .title {
                    margin-top: 10px;
                    padding: 10px 0;
                    font-family: MicrosoftYaHei, MicrosoftYaHei;
                    font-weight: bold;
                    font-size: 16px;
                    color: #11192D;
                    line-height: 21px;
                    text-align: left;
                    font-style: normal;
                    padding-bottom: 8px;
                }

                .SpecificationIMG {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    // padding-top: 10px;
                    margin-top: 10px;

                    .Specificationitem {
                        .skudata {
                            margin-bottom: 5px;
                            padding: 0 23px;
                            height: 32px;
                            line-height: 32px;
                            margin-right: 15px;
                            border-radius: 16px;
                        }

                        .checkitemname {
                            background: #0F0F0F;
                            border: 1px solid #747474;
                            font-family: MicrosoftYaHei;
                            font-size: 14px;
                            color: #FFFFFF;
                            text-align: left;
                            font-style: normal;

                        }

                        .itemname {
                            background: #FFFFFF;
                            border: 1px solid #E5E8EC;
                        }

                    }

                    .isDisabled {
                        cursor: not-allowed;
                        opacity: .3;
                    }

                    .checkitem {
                        margin-right: 6px;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        // padding: 5px;
                        border: 1px solid #0F0F0F;
                        justify-content: center;
                        margin-bottom: 10px;
                        color: var(--bs-danger);
                        // background-color: rgba(232, 56, 32, .05);
                        border-radius: 8px;
                        background-color: #fff;
                        box-sizing: border-box;
                        flex-direction: column;

                    }

                    .imgname {
                        width: 88px;
                        white-space: nowrap;
                        /* 不换行 */
                        overflow: hidden;
                        /* 隐藏超出的内容 */
                        text-overflow: ellipsis;
                        /* 用省略号表示被隐藏的部分 */
                        max-width: 88px;
                        /* 设置最大宽度以限制文本的显示长度 */
                        font-family: MicrosoftYaHei;
                        font-size: 12px;
                        color: #0F0F0F;
                        line-height: 12px;
                        text-align: left;
                        font-style: normal;
                        padding: 4px 0 12px 0;
                    }

                    .item {
                        margin-right: 6px;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        // padding: 5px;
                        // border: 2px solid #ffffff00;
                        // border: 2px solid #e5eaee;
                        justify-content: center;
                        // border-radius: 5px;
                        // background-color: #fff;
                        box-sizing: border-box;
                        margin-bottom: 10px;
                        background: #FFFFFF;
                        border-radius: 8px;
                        border: 1px solid #E1E1E1;
                        flex-direction: column;
                    }

                    // display: grid;
                    // grid-template-columns: repeat(auto-fit, minmax(100px, 0fr));
                    // grid-auto-rows: 100px;
                    // grid-gap: 5px;

                    img {
                        width: 86px;
                        height: 94px;
                        // border-radius: 3px;
                        background-color: #fff;
                        border-radius: 8px 8px 0 0;
                    }
                }

            }

            .number {
                padding-top: 20px;
                margin-bottom: 29px;
                display: flex;
                align-items: center;
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 16px;
                color: #11192D;
                line-height: 21px;
                text-align: left;
                font-style: normal;
            }

            .buts {
                .isDisabled {
                    cursor: not-allowed;
                    opacity: .3;
                }

                display: flex;
                font-family: MicrosoftYaHei,
                MicrosoftYaHei;
                font-weight: bold;
                font-size: 16px;
                color: #FFFFFF;
                line-height: 21px;
                text-align: left;
                font-style: normal;
                justify-content: space-between;

                .addcart {
                    width: 280px;
                    height: 46px;
                    background: #FB7700;
                    border-radius: 23px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .Buynow {
                    width: 280px;
                    height: 46px;
                    background: #FC3938;
                    border-radius: 23px;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                }
            }
        }
    }

    .goods-footer {
        display: flex;
        margin-top: 30px;
        flex-direction: column;

        .goods-article {
            width: 940px;
            margin-right: 20px;
        }

        .goods-aside {
            width: 100%;
            min-height: 1000px;
        }
    }

    .goods-tabs {
        min-height: 600px;
        background: #fff;
    }

    .goods-warn {
        min-height: 600px;
        background: #fff;
        margin-top: 20px;
    }

    .number-box {
        display: flex;
        align-items: center;

        .label {
            width: 60px;
            color: #999;
            padding-left: 10px;
        }
    }

    .g-name {
        font-size: 22px;
    }

    .g-desc {
        color: #999;
        margin-top: 10px;
    }

    .g-price {
        margin-top: 10px;

        span {
            color: $priceColor;
            margin-right: 10px;
            font-size: 22px;

            &::before {
                // content: "¥";
                font-size: 14px;
            }

            // &:first-child {
            //     color: $priceColor;
            //     margin-right: 10px;
            //     font-size: 22px;
            // }

            // &:last-child {
            //     color: #999;
            //     text-decoration: line-through;
            //     font-size: 16px;
            // }
        }
    }

    .g-service {
        background: #f5f5f5;
        width: 500px;
        padding: 20px 10px 0 10px;
        margin-top: 10px;

        dl {
            padding-bottom: 20px;
            display: flex;
            align-items: center;

            dt {
                width: 50px;
                color: #999;
            }

            dd {
                color: #666;

                &:last-child {
                    span {
                        margin-right: 10px;

                        &::before {
                            content: "•";
                            color: $xtxColor;
                            margin-right: 2px;
                        }
                    }

                    a {
                        color: $xtxColor;
                    }
                }
            }
        }
    }

    .goods-sales {
        display: flex;
        width: 400px;
        height: 60px;
        margin-top: 10px;
        justify-content: flex-start;
        margin-left: 37px;

        li {
            padding: 0 0px;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;

            ~li::after {
                position: absolute;
                top: 10px;
                left: 0;
                height: 60px;
                border-left: 1px solid #e4e4e4;
                content: "";
            }

            p {
                &:first-child {
                    color: #999;
                }

                &:nth-child(2) {
                    color: $priceColor;
                    margin-top: 10px;
                }

                &:last-child {
                    color: #666;
                    margin-top: 10px;

                    i {
                        color: $xtxColor;
                        font-size: 14px;
                        margin-right: 2px;
                    }

                    &:hover {
                        color: $xtxColor;
                        cursor: pointer;
                    }
                }
            }
        }
    }
}

.goods-tabs {
    min-height: 600px;
    background: #fff;

    nav {
        height: 70px;
        line-height: 70px;
        display: flex;
        border-bottom: 1px solid #f5f5f5;

        a {
            padding: 0 40px;
            font-size: 18px;
            position: relative;

            >span {
                color: $priceColor;
                font-size: 16px;
                margin-left: 10px;
            }
        }
    }
}

.goods-detail {
    padding: 40px;

    .attrs {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 30px;

        li {
            display: flex;
            margin-bottom: 10px;
            width: 50%;

            .dt {
                width: 100px;
                color: #999;
            }

            .dd {
                flex: 1;
                color: #666;
            }
        }
    }

    >img {
        width: 100%;
    }
}

.btn {
    margin-top: 20px;

}

.bread-container {
    padding: 25px 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .Specification {
        padding-top: 10px;

        .title {
            // padding: 12px 0;
            padding-bottom: 19px;
            // margin-bottom: 19px;
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 16px;
            color: #222222;
            line-height: 16px;
            text-align: left;
            font-style: normal;
        }

        .SpecificationIMG {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            padding-bottom: 10px;

            .isDisabled {
                cursor: not-allowed;
                opacity: .3;
            }

            .checkitem {
                margin-right: 6px;
                display: flex;
                flex-direction: row;
                align-items: center;
                // padding: 5px;
                border: 1px solid #0F0F0F;
                justify-content: center;
                margin-bottom: 10px;
                color: var(--bs-danger);
                // background-color: rgba(232, 56, 32, .05);
                border-radius: 8px;
                background-color: #fff;
                box-sizing: border-box;
                flex-direction: column;

            }

            .Specificationitem {
                .skudata {
                    margin-bottom: 5px;
                    padding: 0 23px;
                    height: 32px;
                    line-height: 32px;
                    margin-right: 15px;
                    border-radius: 16px;
                }

                .checkitemname {
                    background: #0F0F0F;
                    border: 1px solid #747474;
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #FFFFFF;
                    text-align: left;
                    font-style: normal;

                }

                .itemname {

                    background: #FFFFFF;
                    border: 1px solid #E5E8EC;

                }

            }



            .imgname {
                width: 78px;
                white-space: nowrap;
                /* 不换行 */
                overflow: hidden;
                /* 隐藏超出的内容 */
                text-overflow: ellipsis;
                /* 用省略号表示被隐藏的部分 */
                max-width: 88px;
                /* 设置最大宽度以限制文本的显示长度 */
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #0F0F0F;
                line-height: 12px;
                text-align: left;
                font-style: normal;
                padding: 4px 0 12px 0;
            }

            .item {
                margin-right: 6px;
                display: flex;
                flex-direction: row;
                align-items: center;
                // padding: 5px;
                // border: 2px solid #ffffff00;
                // border: 2px solid #e5eaee;
                justify-content: center;
                // border-radius: 5px;
                // background-color: #fff;
                box-sizing: border-box;
                margin-bottom: 10px;
                background: #FFFFFF;
                border-radius: 8px;
                border: 1px solid #E1E1E1;
                flex-direction: column;
            }

            // display: grid;
            // grid-template-columns: repeat(auto-fit, minmax(100px, 0fr));
            // grid-auto-rows: 100px;
            // grid-gap: 5px;

            img {
                width: 78px;
                height: 78px;
                // border-radius: 3px;
                background-color: #fff;
                border-radius: 8px;
            }
        }

    }

    .phoneDIV {
        padding-bottom: 70px;
        background: #f4f5f7;

        .topdiv {
            left: 0;
            top: 0;
            z-index: 999;
            background-color: #fff;
            // border-bottom: 1px solid #e4e4e4;
            // 此处为关键样式!!!
            // 状态一：往上平移自身高度 + 完全透明
            transform: translateY(-100%);
            padding: 8px 15px 0 15px;
            display: flex;
            justify-content: space-between;
            justify-content: space-between;
            background-color: rgb(130 137 145 / 0%) !important;
            width: 100%;
            position: fixed;
            // z-index: 999;

            .img {
                width: 28px;
                height: 28px;
                background-color: #f4f5f700 !important;

                img {
                    background-color: #f4f5f700;
                }
            }

            // 状态二：移除平移 + 完全不透明
            &.show {
                transition: all 0.3s linear;
                transform: none;
                opacity: 1;
                background-color: #ffffff;
            }
        }

        .notopdiv {
            height: 44px;
            left: 0;
            top: 0;
            z-index: 999;
            background-color: #fff;
            // border-bottom: 1px solid #e4e4e4;
            // 此处为关键样式!!!
            // 状态一：往上平移自身高度 + 完全透明
            transform: translateY(-100%);
            padding: 0px 20px 0 15px;
            display: flex;
            justify-content: space-between;
            justify-content: space-between;
            background-color: #fff !important;
            width: 100%;
            position: fixed;
            /* left: 0; */
            /* top: 0; */
            z-index: 999;
            display: flex;
            align-items: center;

            .img {
                width: 20px;
                height: 20px;
                background-color: #f4f5f700 !important;

                img {
                    background-color: #f4f5f700;
                }
            }

            // 状态二：移除平移 + 完全不透明
            &.show {
                transition: all 0.3s linear;
                transform: none;
                opacity: 1;
                background-color: #ffffff;
            }
        }
    }

    .carousel {
        img {
            width: 100%;
            height: 100%;
        }
    }

    .ProductInfo {
        padding: 10px 15px 40px 15px;
        background: #ffffff;

        .ProductInfo-title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #222222;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            padding-bottom: 8px;
        }

        .info-Browse {
            display: flex;

            .Browse {
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #777777;
                line-height: 16px;
                text-align: left;
                font-style: normal;
                padding-right: 18px;
            }

            .user-info-img {
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #11192D;
                line-height: 16px;
                text-align: left;
                font-style: normal;
                display: flex;
                align-items: center;

                .userimg {
                    width: 18px;
                    height: 18px;
                    border-radius: 50%;
                    margin-left: 5px;
                }
            }
        }

        .info-price {
            display: flex;
            padding-top: 30px;
            align-items: center;
            margin-bottom: 25px;

            .price {
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                // font-size: 15px;
                font-size: 24px;
                color: #FC3938;
                line-height: 19px;
                text-align: left;
                font-style: normal;
            }

            .liang {
                margin: 0 8px;
                padding: 5px 8px;
                background: #FEF1EA;
                border-radius: 4px;
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #FC3938;
                line-height: 16px;
                text-align: left;
                font-style: normal;
            }
        }

        .hrdiv {
            width: 100%;
            height: 1px;
            border: 1px solid #E1E1E1;
            margin-bottom: 20px;
        }


    }

    .ProductDetails {

        // height: 42px;
        .DetailsTitle {
            padding: 9px 16px;
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 18px;
            color: #333333;
            line-height: 24px;
            text-align: left;
            font-style: normal;
        }

        .Detailscontainer {
            background-color: #ffffff;
        }


    }

    .Product-footer {
        // padding-top: 50px;
        background-color: #ffffff;

        margin-top: 20px;

        .goods-aside {
            background-color: #ffffff;
        }
    }

    .goodsfixed {
        width: 100%;

        width: 100%;
        height: 65px;
        position: fixed;
        padding: 10px 13px;
        bottom: 0;
        z-index: 999;
        background-color: #fff;



        .nocollect {
            color: #b9b4b4;
        }

        .collect {
            color: #e26237;
        }


    }

    .butdiv {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;

        .connect {
            display: flex;
            align-items: center;
            justify-content: center;

            width: 73px;
            height: 35px;
            border-radius: 26px;
            background: #bbeafd;
            font-size: 14px;
        }

        .but {
            display: flex;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 20px;
            text-align: left;
            font-style: normal;

            .addcart {
                // width: 142px;
                padding: 0 23px;
                height: 40px;
                background: #FB7700;
                border-radius: 23px;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .Buynow {
                margin-left: 5px;
                padding: 0 23px;
                height: 40px;
                background: #FC3938;
                border-radius: 23px;
                display: flex;
                justify-content: center;
                align-items: center;

            }
        }

    }

    .closure {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-bottom: 16px;

        img {
            width: 15px;
            height: 15px;
            background-color: #f4f5f700;
        }
    }

    .isDisabled {
        cursor: not-allowed;
        opacity: .3;
    }

    .imgPrice {
        height: 82px;
        display: flex;

        .numprice {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-left: 10px;

            .name {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #222222;
                line-height: 20px;
                text-align: left;
                font-style: normal;
            }

            .price {
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                // font-size: 15px;
                font-size: 18px;
                color: #FC3938;
                line-height: 14px;
                text-align: left;
                font-style: normal;
            }
        }

    }

    .number {
        margin-top: 20px;
        margin-bottom: 29px;
        display: flex;
        align-items: center;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 16px;
        color: #11192D;
        line-height: 21px;
        text-align: left;
        font-style: normal;
    }

    // .drawerSpec {

    //     flex: 1;
    //     padding: 0px 10px 36px 10px;

    //     .drawerbut {
    //         width: 83%;
    //         height: 50px;
    //         position: fixed;
    //         padding: 6px 0px;
    //         text-align: end;
    //         bottom: 0;
    //         z-index: 999;
    //         background-color: #fff;
    //     }

    //     .titlediv {
    //         display: flex;

    //         .titleimg {
    //             width: 120px;
    //             height: 120px;
    //         }

    //         .info {
    //             flex: 1;
    //             padding-left: 10px;
    //         }
    //     }

    //     .freightFee {
    //         margin: 5px 0;
    //         font-size: 14px;
    //         padding: 15px;
    //         border-radius: 6px;
    //         background-color: #f7f8f9;
    //         color: #212529;
    //         display: flex;
    //         align-items: center;

    //         .fee {
    //             background: #e6e9ec;
    //             padding: 6px 10px;
    //             border: 1px solid #eef0f2;
    //             margin-left: 5px;
    //             border-top-left-radius: 10px;
    //             border-bottom-left-radius: 10px;
    //         }

    //         .currency {
    //             padding: 6px 10px;
    //             border-top-right-radius: 10px;
    //             border-bottom-right-radius: 10px;
    //             background-color: #f7f8f9;
    //             border: 1px solid #eef0f2;
    //         }
    //     }

    //     .Specification {
    //         .title {
    //             padding: 10px 0;
    //         }

    //         .SpecificationIMG {
    //             display: flex;
    //             flex-direction: row;
    //             flex-wrap: wrap;

    //             .isDisabled {
    //                 cursor: not-allowed;
    //                 opacity: .3;
    //             }

    //             .checkitem {
    //                 margin-right: 8px;
    //                 display: flex;
    //                 flex-direction: row;
    //                 align-items: center;
    //                 // padding: 5px;
    //                 border: 2px solid red;
    //                 justify-content: center;
    //                 margin-bottom: 5px;
    //                 color: var(--bs-danger);
    //                 background-color: rgba(232, 56, 32, .05);
    //                 border-radius: 5px;
    //                 box-sizing: border-box;
    //             }

    //             .item {
    //                 margin-right: 8px;
    //                 display: flex;
    //                 flex-direction: row;
    //                 align-items: center;
    //                 // padding: 5px;
    //                 border: 2px solid #e5eaee;
    //                 justify-content: center;
    //                 margin-bottom: 5px;
    //                 border-radius: 5px;
    //                 box-sizing: border-box;
    //             }

    //             // display: grid;
    //             // grid-template-columns: repeat(auto-fit, minmax(100px, 0fr));
    //             // grid-auto-rows: 100px;
    //             // grid-gap: 5px;

    //             img {
    //                 width: 40px;
    //                 height: 40px;
    //                 border-radius: 3px;
    //                 background-color: #fff;
    //             }
    //         }

    //     }

    // }

    // .container {
    //     width: 100%;
    // }

    // .xtx-goods-page {
    //     .leaveComments{
    //     .title{
    //         padding: 14px 10px;
    //         margin-top: 25px;
    //         display: flex;
    //         align-items: center;
    //         justify-content: space-between;
    //         border: 0px solid rgb(238, 238, 238);
    //         background: rgb(226, 98, 55);
    //         font-size: 14px;
    //         color: rgb(255, 255, 255);
    //     }
    //     .content{
    //         background-color: #fff;
    //         display: flex;
    //         flex-direction: column;
    //         // display: grid;
    //         // grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    //         // grid-auto-rows: 18px;
    //         grid-gap: 0px;
    //         padding: 10px 10px 30px 10px;
    //         .item{
    //             padding: 10px;
    //             display: flex;
    //             flex-direction: row;
    //             .lable{
    //                 width: 150px;
    //                 font-size: 13px;
    //                 color: #999;
    //             }
    //             .value{
    //                 flex: 1;
    //                 font-size: 13px;
    //                 color: #333;

    //             }
    //         }
    //     }
    // }
    //     .goods-info {
    //         min-height: 600px;
    //         background: #fff;
    //         display: flex;
    //         flex-direction: column;

    //         .media {
    //             width: 100%;
    //             height: 515px;
    //             padding: 64px 0 0 0;
    //         }

    //         .spec {
    //             flex: 1;
    //             padding: 94px 10px 4px 10px;

    //             .freightFee {
    //                 margin: 5px 0;
    //                 font-size: 14px;
    //                 padding: 15px;
    //                 border-radius: 6px;
    //                 background-color: #f7f8f9;
    //                 color: #212529;
    //                 display: flex;
    //                 align-items: center;

    //                 .fee {
    //                     background: #e6e9ec;
    //                     padding: 6px 10px;
    //                     border: 1px solid #eef0f2;
    //                     margin-left: 5px;
    //                     border-top-left-radius: 10px;
    //                     border-bottom-left-radius: 10px;
    //                 }

    //                 .currency {
    //                     padding: 6px 10px;
    //                     border-top-right-radius: 10px;
    //                     border-bottom-right-radius: 10px;
    //                     background-color: #f7f8f9;
    //                     border: 1px solid #eef0f2;
    //                 }
    //             }

    //             .Specification {
    //                 .SpecificationIMG {
    //                     display: flex;
    //                     flex-direction: row;
    //                     flex-wrap: wrap;

    //                     .checkitem {
    //                         margin-right: 5px;
    //                         display: flex;
    //                         flex-direction: row;
    //                         align-items: center;
    //                         padding: 5px;
    //                         border: 1px solid red;
    //                         justify-content: center;
    //                         margin-bottom: 5px;
    //                         border-radius: 5px;
    //                     }

    //                     .item {
    //                         margin-right: 5px;
    //                         display: flex;
    //                         flex-direction: row;
    //                         align-items: center;
    //                         padding: 5px;
    //                         border: 1px solid #e9e9eb;
    //                         justify-content: center;
    //                         margin-bottom: 5px;
    //                         border-radius: 5px;
    //                     }

    //                     // display: grid;
    //                     // grid-template-columns: repeat(auto-fit, minmax(100px, 0fr));
    //                     // grid-auto-rows: 100px;
    //                     // grid-gap: 5px;

    //                     img {
    //                         width: 42px;
    //                         height: 42px;
    //                     }
    //                 }

    //             }
    //         }
    //     }

    //     .goods-footer {
    //         display: flex;
    //         // margin-top: 20px;
    //         flex-direction: column;
    //         padding-bottom: 80px;

    //         .goods-article {
    //             width: 940px;
    //             margin-right: 20px;
    //         }

    //         .goods-aside {
    //             width: 280px;
    //             min-height: 1000px;
    //         }
    //     }

    //     .goodsfixed {
    //         width: 100%;

    //         width: 100%;
    //         height: 70px;
    //         position: fixed;
    //         padding: 13px 31px;
    //         text-align: end;
    //         bottom: 0;
    //         z-index: 999;
    //         background-color: #fff;

    //     }

    //     .goods-tabs {
    //         min-height: 600px;
    //         background: #fff;
    //     }

    //     .goods-warn {
    //         min-height: 600px;
    //         background: #fff;
    //         margin-top: 20px;
    //     }

    //     .number-box {
    //         display: flex;
    //         align-items: center;

    //         .label {
    //             width: 60px;
    //             color: #999;
    //             padding-left: 10px;
    //         }
    //     }

    //     .g-name {
    //         font-size: 16px;
    //     }

    //     .g-desc {
    //         color: #999;
    //         margin-top: 10px;
    //     }

    //     .g-price {
    //         margin-top: 10px;

    //         span {
    //             color: $priceColor;
    //             margin-right: 10px;
    //             font-size: 22px;

    //             &::before {
    //                 // content: "¥";
    //                 font-size: 14px;
    //             }

    //             // &:first-child {
    //             //     color: $priceColor;
    //             //     margin-right: 10px;
    //             //     font-size: 22px;
    //             // }

    //             // &:last-child {
    //             //     color: #999;
    //             //     text-decoration: line-through;
    //             //     font-size: 16px;
    //             // }
    //         }
    //     }

    //     .g-service {
    //         background: #f5f5f5;
    //         width: 500px;
    //         padding: 20px 10px 0 10px;
    //         margin-top: 10px;

    //         dl {
    //             padding-bottom: 20px;
    //             display: flex;
    //             align-items: center;

    //             dt {
    //                 width: 50px;
    //                 color: #999;
    //             }

    //             dd {
    //                 color: #666;

    //                 &:last-child {
    //                     span {
    //                         margin-right: 10px;

    //                         &::before {
    //                             content: "•";
    //                             color: $xtxColor;
    //                             margin-right: 2px;
    //                         }
    //                     }

    //                     a {
    //                         color: $xtxColor;
    //                     }
    //                 }
    //             }
    //         }
    //     }

    //     .goods-sales {
    //         display: flex;
    //         width: 90%;

    //         height: 60px;

    //         margin-top: 65px;
    //         justify-content: flex-start;
    //         margin-left: 0px;

    //         li {
    //             // flex: 1;
    //             position: relative;
    //             padding: 0 16px;
    //             ~li::after {
    //                 position: absolute;
    //                 top: 10px;
    //                 left: 0;
    //                 height: 60px;
    //                 border-left: 1px solid #e4e4e4;
    //                 content: "";
    //             }

    //             p {
    //                 &:first-child {
    //                     color: #999;
    //                 }

    //                 &:nth-child(2) {
    //                     color: $priceColor;
    //                     margin-top: 10px;
    //                 }

    //                 &:last-child {
    //                     color: #666;
    //                     margin-top: 0px;

    //                     i {
    //                         color: $xtxColor;
    //                         font-size: 14px;
    //                         margin-right: 2px;
    //                     }

    //                     &:hover {
    //                         color: $xtxColor;
    //                         cursor: pointer;
    //                     }
    //                 }
    //             }
    //         }
    //     }
    // }

    // .goods-tabs {
    //     min-height: 600px;
    //     background: #fff;

    //     nav {
    //         height: 70px;
    //         line-height: 70px;
    //         display: flex;
    //         border-bottom: 1px solid #f5f5f5;

    //         a {
    //             padding: 0 40px;
    //             font-size: 18px;
    //             position: relative;

    //             >span {
    //                 color: $priceColor;
    //                 font-size: 16px;
    //                 margin-left: 10px;
    //             }
    //         }
    //     }
    // }

    // .goods-detail {
    //     padding: 40px;

    //     .attrs {
    //         display: flex;
    //         flex-wrap: wrap;
    //         margin-bottom: 30px;

    //         li {
    //             display: flex;
    //             margin-bottom: 10px;
    //             width: 50%;

    //             .dt {
    //                 width: 100px;
    //                 color: #999;
    //             }

    //             .dd {
    //                 flex: 1;
    //                 color: #666;
    //             }
    //         }
    //     }

    //     >img {
    //         width: 100%;
    //     }
    // }

    // .btn {
    //     margin-top: 0px;

    // }

    // .bread-container {
    //     padding: 25px 0;
    // }
}
</style>